import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'us-east-2_o0Kb7rT6a',
  ClientId: '3cga58l6naovf4l8733e47drr5',
};

export default new CognitoUserPool(poolData);
